import { createStore, StoreOptions } from 'vuex'

export interface CustomState {
  index: number;
  first: boolean;
}

export default createStore(<StoreOptions<CustomState>>{
  state: {
    index: 0,
    first: true,
  },
  mutations: {
    next (state) {
      state.index = Math.round(state.index + 1);
    },
    prev (state) {
      state.index = Math.round(state.index - 1);
    },
    scrollLeft (state) {
      state.index = state.index + 0.01;
    },
    scrollRight (state) {
      state.index = state.index - 0.01;
    },
    goto (state, n: number) {
      state.index = n;
    },
    first (state, bool: boolean) {
      state.first = bool;
    },
  },
  actions: {
  },
  modules: {
  }
})
